import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import { handleArmSite } from "./SiteAboutPageUtils/handleArmSite";
import { useNavigate } from "react-router-dom";
import { AlertState, SiteInfo } from "./SiteAboutPageUtils/siteAboutInterfaces";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const ArmSiteDialog = ({
  armDialogOpen,
  setArmDialogOpen,
  setSiteInfo,
  setBackdropLoadingScreenOn,
  setAlertState,
  setSyncNeeded,
  setArmedStatus,
  setArmButtonDisabled,
}: {
  armDialogOpen: boolean;
  setArmDialogOpen: Dispatcher<boolean>;
  setSiteInfo: Dispatcher<SiteInfo>;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  setAlertState: Dispatcher<AlertState>;
  setSyncNeeded: Dispatcher<boolean>;
  setArmedStatus: Dispatcher<boolean>;
  setArmButtonDisabled: any;
}) => {
  const navigate = useNavigate();
  return (
    <Dialog
      open={armDialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {" Are you sure you want to arm this site?"}
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Site will disarm at next scheduled disarm time.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setArmDialogOpen(false);
            setSiteInfo((previousState: SiteInfo) => {
              return { ...previousState, armed: false };
            });
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            handleArmSite(
              setBackdropLoadingScreenOn,
              setSiteInfo,
              setAlertState,
              setSyncNeeded,
              setArmedStatus,
              navigate,
              setArmButtonDisabled
            );
            setSiteInfo((previousState: SiteInfo) => {
              return { ...previousState, armed: true };
            });
            setArmDialogOpen(false);
          }}
          text="Arm Site"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
